import { Box, MenuItem, Select } from '@mui/material'
import { PLAN_ACCESS_OPTIONS } from 'Common/Constants/Constants'
import { PlanAccessSelectProps } from './Common.types'

// Squared, compact control matching the Scheduler design system (see
// Features/Scheduler/SchedulerDesign.tsx) — a plain bordered box with an
// uppercase micro-label above it, rather than MUI's floating notched label.
// Hex values are duplicated from SchedulerDesign's TOKENS rather than
// imported, since Common/* stays independent of Features/* — this control
// is currently only used by the Scheduler feature.
const INK_400 = '#71808A'
const INK_900 = '#0E1B22'
const LINE_300 = '#C5D0D7'
const BRAND_TEAL = '#00415A'
const FONT_SANS = "'Archivo', system-ui, -apple-system, sans-serif"

export const PlanAccessSelect = ({
  showPlansOption,
  handleShowMyPlansDropdown,
  label = 'Plan access',
}: PlanAccessSelectProps) => (
  <Box sx={{ display: 'inline-flex', flexDirection: 'column', gap: '3px' }}>
    <Box
      component="label"
      htmlFor="access-type-select"
      sx={{
        fontFamily: FONT_SANS,
        fontSize: 10.5,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: INK_400,
      }}
    >
      {label}
    </Box>
    <Select
      id="access-type-select"
      value={showPlansOption}
      onChange={handleShowMyPlansDropdown}
      sx={{
        width: 220,
        height: 30,
        background: '#fff',
        fontFamily: FONT_SANS,
        fontSize: 12.5,
        color: INK_900,
        borderRadius: '3px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: LINE_300 },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: LINE_300 },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: BRAND_TEAL,
          borderWidth: '1px',
        },
        '& .MuiSelect-select': { paddingTop: '6px', paddingBottom: '6px' },
      }}
      MenuProps={{ PaperProps: { sx: { borderRadius: '3px' } } }}
    >
      <MenuItem
        value={PLAN_ACCESS_OPTIONS['Generated by me']}
        sx={{ fontFamily: FONT_SANS, fontSize: 12.5 }}
      >
        {PLAN_ACCESS_OPTIONS['Generated by me']}
      </MenuItem>
      <MenuItem
        value={PLAN_ACCESS_OPTIONS['Not generated by me']}
        sx={{ fontFamily: FONT_SANS, fontSize: 12.5 }}
      >
        {PLAN_ACCESS_OPTIONS['Not generated by me']}
      </MenuItem>
      <MenuItem
        value={PLAN_ACCESS_OPTIONS['Generated by anyone']}
        sx={{ fontFamily: FONT_SANS, fontSize: 12.5 }}
      >
        {PLAN_ACCESS_OPTIONS['Generated by anyone']}
      </MenuItem>
    </Select>
  </Box>
)
